import { useCallback } from "react"
import { useMutation } from "react-relay"
import { Ch_verifyMedicationInput } from "@/modules/patients/detail/medication/ch/services/__generated__/chVerifyMedicationMutation.graphql"
import { chVerifyMedicationMutation as chMutation } from "@/modules/patients/detail/medication/ch/services/chVerifyMedicationMutation"
import { De_verifyMedicationInput } from "@/modules/patients/detail/medication/de/services/__generated__/deVerifyMedicationMutation.graphql"
import { deVerifyMedicationMutation as deMutation } from "@/modules/patients/detail/medication/de/services/deVerifyMedicationMutation"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { Country } from "@/types/__generated__/union-types"

const getMutationByCountry = (country: Country) => {
  switch (country) {
    case "DE":
      return deMutation
    case "CH":
      return chMutation
  }
}

const useVerifyMedicationMutation = () => {
  const country = useCountryParam()
  const [commit] = useMutation(getMutationByCountry(country))

  return useCallback(
    (input: De_verifyMedicationInput | Ch_verifyMedicationInput, onCompleted?: () => void) => {
      commit({
        variables: {
          input,
        },
        onCompleted,
      })
    },
    [commit],
  )
}

export { useVerifyMedicationMutation }
